import {
  PaginationContainer,
  PaginationOptionsContainer,
} from 'shared/table/components/TablePagination/TablePagination.styles';
import { TextPlaceholder } from './TextPlaceholder';
import styled from 'styled-components';

const Pagination = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: end;
  justify-content: flex-end;
  width: 100%;
  gap: 40px;
`;

export const TablePaginationPlaceholder = () => {
  return (
    <PaginationContainer>
      <PaginationOptionsContainer>
        <TextPlaceholder height={24} width={145} />
        <TextPlaceholder height={40} width={60} />
      </PaginationOptionsContainer>
      <Pagination>
        <TextPlaceholder height={24} width={150} />
        <TextPlaceholder height={40} width={190} />
      </Pagination>
    </PaginationContainer>
  );
};
